import makeRequest from './base.request'

export const getConteudosSearch = async (search) => {
    try {
        const response = await makeRequest.get('estudo/biblioteca?search='+search);
        var estudos = response.estudos;
        return estudos;
        
    } catch (error) {
        console.error(error);
    }
}
